import React, { useState, useEffect, useLayoutEffect, useRef, useCallback, } from 'react';
import HeadSub from "../../../components/comm/HeadSub";
import style from './Chat.module.css';
import axiosApi from '../../../api/daonAxios';
import axios from 'axios';
import dayjs from 'dayjs'
import ChatListComp from './chatcomp/ChatListComp'
import CODE from '../../../constants/code';
import URL from '../../../constants/url';
import { SERVER_URL } from '../../../constants/url';
import iconAttach from '../../../images/common/i_chat_attach.svg';
import iconVoice from '../../../images/common/i_chat_voice.svg';

import { fetchEventSource } from '@microsoft/fetch-event-source';

import { getDpAuthRefeshTokenSimple } from '../../../assets/js/comm';
import { useLocation } from 'react-router-dom';


const ServiceChat = () => {

    const location = useLocation();
    const { state } = location;

    const mode = state?.mode === 'exercise' ? 'exercise' : 'diet';
    const aiComment = state?.aiComment || '';

    // 해당 진입에서 첫 사용자 요청에 전달할 entryContext
    const initialConnectRef = useRef(true);

    // 같은 ServiceChat 컴포넌트가 유지된 상태에서
    // 코멘트를 다시 클릭해 진입하는 경우에도 초기화
    useEffect(() => {
        initialConnectRef.current = true;
    }, [location.key]);

    //렌더전용으로 사용할것.
    const initializedRef = useRef(false);

    const chatEndRef = useRef(null);                        //스크롤
    const [textQuestion, setTextQuestion] = useState("");   //입력 텍스트
    const [chatList, setChatList] = useState([]); // 채팅

    // SSE 연결 종료용
    const sseAbortControllerRef = useRef(null);

    // 브라우저와 백엔드 사이 SSE 식별값
    const sessionIdRef = useRef(crypto.randomUUID());

    // 현재 스트리밍 중인 AI 메시지 식별값
    const streamingMessageIdRef = useRef(null);

    const [isSending, setIsSending] = useState(false);
    const [isFlying, setIsFlying] = useState(false);    // 챗 보낸때 애니메이션

    const [sseStatus, setSseStatus] = useState("connecting");
    const [queueStatus, setQueueStatus] = useState(null);

    const lastAiMessageIdRef = useRef(null);

    const isRefreshingRef = useRef(false);

    // 키보드가 덮는 높이(px)
    const [keyboardHeight, setKeyboardHeight] = useState(0);
    const topAnchorRef = useRef(null);
    const appliedKbRef = useRef(0);
    const scrollBoxRef = useRef(null);


    const connectSse = useCallback(() => {
        setSseStatus("connecting");


        // 기존 연결이 있으면 종료
        if (sseAbortControllerRef.current) {
            sseAbortControllerRef.current.abort();
        }

        const controller = new AbortController();
        sseAbortControllerRef.current = controller;

        const sessionId = sessionIdRef.current;
        const baseUrl = axiosApi.defaults.baseURL;
        const jToken = localStorage.getItem("jToken");

        console.log(
            "[SSE CONNECT]",
            "sessionId =", sessionId
        );

        const sseUrl =
            `${baseUrl}/chat/stream?sessionId=${encodeURIComponent(sessionId)}`;

        fetchEventSource(sseUrl, {
            method: "GET",

            headers: {
                Authorization: `Bearer ${jToken}`,
                Accept: "text/event-stream",
            },

            signal: controller.signal,

            // 브라우저 탭이 background 상태가 되어도 연결 유지
            openWhenHidden: true,

            async onopen(response) {
                if (response.ok) {
                    console.log("SSE 연결 성공");
                    setSseStatus("connected");
                    return;
                }

                console.error(
                    "SSE 연결 실패",
                    response.status,
                    response.statusText
                );

                // 토큰 만료
                if (response.status === 401) {
                    console.log("SSE access token 만료 - 갱신 시도");

                    // 현재 SSE 재시도 중단
                    controller.abort();

                    // 이미 다른 쪽에서 토큰 갱신 중이면
                    // 잠깐 후 새 토큰으로 SSE만 다시 연결
                    if (isRefreshingRef.current) {
                        setTimeout(() => {
                            connectSse();
                        }, 500);
                        return;
                    }

                    isRefreshingRef.current = true;

                    try {
                        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));

                        if (!loginUser?.usrUid || !loginUser?.crtfcTknVal) {
                            throw new Error("refresh token 정보 없음");
                        }

                        const data = await getDpAuthRefeshTokenSimple(loginUser.crtfcTknVal);

                        const { accessToken, refreshToken } = data;

                        // 새 토큰 저장
                        localStorage.setItem("jToken", accessToken);
                        localStorage.setItem("IITP_CRTFC_TKN", refreshToken);

                        // 서버에도 refresh token 갱신
                        const requestCdssUrl = SERVER_URL + "/signup/saveRefreshToken";

                        const userReq = {
                            crtfcTknVal: refreshToken,
                            usrInfoId: loginUser.usrInfoId,
                            usrUid: loginUser.usrUid,
                        };

                        const refreshResp = await axios.post(
                            requestCdssUrl,
                            userReq,
                            {
                                headers: {
                                    Authorization: `Bearer ${accessToken}`,
                                },
                                withCredentials: true,
                            }
                        );

                        if (Number(refreshResp.data.resultCode) ===Number(CODE.RCV_SUCCESS)) {
                            sessionStorage.setItem("loginUser", JSON.stringify(refreshResp.data.result.userInfo));

                            console.log("SSE 토큰 갱신 완료 - 재연결");

                            // 새 토큰으로 새 fetchEventSource 생성
                            connectSse();
                            return;
                        }

                        throw new Error("refresh token 서버 저장 실패");

                    } catch (error) {
                        console.error("SSE 인증정보 갱신 실패", error);

                        localStorage.setItem("jToken", "");
                        localStorage.setItem("BREAST_CRTFC_TKN","");

                        sessionStorage.setItem("loginUser", JSON.stringify({}));

                        window.history.replaceState(null, "", URL.MAIN);

                        window.location.href = URL.MAIN;
                    } finally {
                        isRefreshingRef.current = false;
                    }

                    return;
                }

                // 401이 아닌 오류는 fetchEventSource 자동 retry 대상
                throw new Error(`SSE 연결 실패: ${response.status}`);
            },

            onmessage(event) {
                try {
                    console.log(
                        "SSE 이벤트 수신:",
                        event.event,
                        event.data
                    );

                    const rawData = event.data?.trim();

                    if (!rawData) {
                        console.debug('빈 SSE 이벤트 무시');
                        return;
                    }

                    const data = JSON.parse(event.data);

                    switch (event.event) {
                        case "queue_status":
                            handleQueueStatus(data);
                            break;

                        case "selection_box": {
                            setQueueStatus(null);
                            setIsSending(false);

                            const targetMessageId =
                                streamingMessageIdRef.current ||
                                lastAiMessageIdRef.current;

                            if (targetMessageId) {
                                setChatList(prev =>
                                    prev.map(item =>
                                        item.id === targetMessageId
                                            ? {
                                                ...item,
                                                responseType: "selection_box",
                                                text: data.text || item.text,
                                                messageTitle: data.message_title,
                                                tables: data.tables || [],
                                                tags: data.selections || [],
                                                isStreaming: false,
                                            }
                                            : item
                                    )
                                );

                                streamingMessageIdRef.current = null;
                                break;
                            }

                            // STREAM 없이 selection_box만 바로 온 경우
                            setChatList(prev => [
                                ...prev,
                                {
                                    id: crypto.randomUUID(),
                                    type: "bot",
                                    responseType: "selection_box",
                                    text: data.text,
                                    messageTitle: data.message_title,
                                    tags: data.selections || [],
                                    date: getCurrentDate(),
                                    chatTime: getCurrentTime(),
                                    isStreaming: false,
                                    tables: data.tables || [],
                                },
                            ]);

                            break;
                        }

                        case "input_box":
                            setQueueStatus(null);
                            setIsSending(false);

                            setChatList(prev => [
                                ...prev,
                                {
                                    id: crypto.randomUUID(),
                                    type: "bot",
                                    responseType: "input_box",
                                    text: data.text,
                                    messageTitle: data.message_title,
                                    tables: data.tables || [],
                                    inputs: data.inputs || [],
                                    date: getCurrentDate(),
                                    chatTime: getCurrentTime(),
                                },
                            ]);
                            break;

                        // event: message 또는 event가 없는 일반 SSE
                        case "message":
                        case "":
                        default:
                            handleSseMessage(data);
                            break;
                    }

                } catch (error) {
                    console.error(
                        "SSE 메시지 처리 실패",
                        error,
                        event.data
                    );
                }
            },

            onclose() {
                console.log("SSE 연결 종료");

                if (!controller.signal.aborted) {
                    setSseStatus("connecting");

                    setTimeout(() => {
                        connectSse();
                    }, 1000);
                }
            },

            onerror(error) {
                // 우리가 abort()해서 끊은 거면 오류 처리 X
                if (controller.signal.aborted) {
                    return;
                }

                console.warn("SSE 연결 오류 - 재연결 시도", error);
                setSseStatus("connecting");

                // throw 하면 fetchEventSource 자동 재연결 중단
                // throw error;
            },
        });

        return controller;

    }, []);


    const initRequestedRef = useRef(false);

    useEffect(() => {
        if (initRequestedRef.current) {
            return;
        }

        initRequestedRef.current = true;
        getChatbotInitInfo(1);
    }, []);

    useEffect(() => {
        const controller = connectSse();

        return () => {
            controller?.abort();

            if (sseAbortControllerRef.current === controller) {
                sseAbortControllerRef.current = null;
            }
        };
    }, [connectSse]);


    const getChatbotInitInfo = useCallback(async (patntInfoId) => {

        const jToken = localStorage.getItem('jToken');
        const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

        const requestOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
            params: {
                patntInfoId: patntInfoId
            }
        };

        try {
            const res = await axiosApi.get('/chat/init', requestOptions);

            if (res.status === 200) {

                const { chatList = [] } = res.data.result;

                // 오늘 채팅 내역 변환
                const history = convertChatHistory(chatList);

                const welcomeMsg = '안녕하세요! 저는 건강관리를 도와주는 웰비예요.';

                if (history.length > 0) {

                    // 날짜 구분선과 실제 채팅 내역 분리
                    const [dateMessage, ...messages] = history;

                    // 날짜 → 환영 메시지 → 기존 대화 → AI 코멘트
                    setChatList([
                        dateMessage,
                        {
                            id: crypto.randomUUID(),
                            type: 'bot',
                            text: welcomeMsg,
                            source: 'init',
                            date: getCurrentDate(),
                            chatTime: getCurrentTime(),
                        },
                        ...messages,

                        // AI 코멘트가 있을 때만 추가
                        ...(aiComment?.trim() ? [{
                            id: crypto.randomUUID(),
                            type: 'bot',
                            text: aiComment,
                            source: 'init',
                            date: getCurrentDate(),
                            chatTime: getCurrentTime(),
                        }] : [])
                    ]);


                } else {

                    // 오늘 채팅 내역이 없으면 환영 메시지 출력
                    initMsg(
                        aiComment?.trim()
                            ? `${welcomeMsg}\n${aiComment}`
                            : welcomeMsg
                    );

                }
            }

        } catch (error) {
            console.error('채팅 초기화 오류:', error);
        }

    }, [mode, aiComment]);

    const initMsg = (text) => {
        setChatList(prev => {
            const list = [...prev];

            // 최초 한 번만 날짜 추가
            if (list.length === 0) {
                list.push({
                    type: 'date',
                    dateStr: getCurrentDateStr(),
                    date: getCurrentDate(),
                });
            }

            list.push({
                type: 'bot',
                text,
                source: 'init',
                date: getCurrentDate(),
                chatTime: getCurrentTime(),
            });

            return list;
        });
    };


    useEffect(() => {

        document.body.classList.remove('modal-open');
    }, []);


    // 크롬이 키보드 때문에 밀어올린 화면을 되돌리는 기능
    const unpan = useCallback(() => {
        const vv = window.visualViewport;
        if (!vv || !appliedKbRef.current || vv.offsetTop <= 0) return;

        topAnchorRef.current?.scrollIntoView({ block: 'start' });
    }, []);

    // 키보드 높이 재서 입력창만 올리는 기능
    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;

        const vk = navigator.virtualKeyboard;
        if (vk) vk.overlaysContent = true;

        const sync = () => {
            setKeyboardHeight(Math.max(0, window.innerHeight - vv.height));
        };

        sync();
        vv.addEventListener('resize', sync);
        vv.addEventListener('scroll', unpan);

        return () => {
            vv.removeEventListener('resize', sync);
            vv.removeEventListener('scroll', unpan);
            if (vk) vk.overlaysContent = false;
        };
    }, [unpan]);

    useLayoutEffect(() => {
        appliedKbRef.current = keyboardHeight;
        unpan();
    }, [keyboardHeight, unpan]);

    // 새 메시지 오면 대화 목록을 바닥으로 붙이는 기능
    useEffect(() => {
        const box = scrollBoxRef.current;
    //     if (box) box.scrollTop = box.scrollHeight;

    // }, [chatList, keyboardHeight]);
    if (!box) return;

        // 레이아웃 반영 후 측정해야 새로 붙은 말풍선 높이까지 잡힌다
        const raf = requestAnimationFrame(() => {
            box.scrollTop = box.scrollHeight;
        });

        return () => cancelAnimationFrame(raf);
    }, [chatList, keyboardHeight, queueStatus]);

    const handleTagClick = useCallback(
        async (tag, selectionMessageId) => {
            const jToken = localStorage.getItem('jToken');
            const content = tag?.trim();

            const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

            // 어느 병원인지 알 수 없어서 일단 012 하드코딩
            const patientId = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012")?.patientId;

            if (isSending || !content) {
                return;
            }

            if (sseStatus !== "connected") {
                console.error("SSE가 연결되지 않았습니다.");
                return;
            }

            setTextQuestion("");
            setIsSending(true);
            setQueueStatus(null);

            streamingMessageIdRef.current = null;
            lastAiMessageIdRef.current = null;

            // 선택한 selection_box의 버튼을 더 이상 누르지 못하게 처리
            if (selectionMessageId) {
                setChatList(prev =>
                    prev.map(item =>
                        item.id === selectionMessageId
                            ? {
                                ...item,
                                submitted: true,
                                selectedValue: content,
                            }
                            : item
                    )
                );
            }

            // 선택한 항목을 사용자 메시지로 표시
            setChatList(prev => [
                ...prev,
                {
                    id: crypto.randomUUID(),
                    type: "user",
                    text: content,
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                },
            ]);

            try {
                await axiosApi.post(
                    "/chat/send",
                    {
                        sessionId: sessionIdRef.current,
                        message: content,
                        requestedReturnType: "selection_box",
                        patientId: patientId,
                        accessToken: jToken,
                        entryContext: initialConnectRef.current ? "daily_" + mode : "general",
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${jToken}`,
                        },
                        noLoading: true,
                    }
                );
                initialConnectRef.current = false;
                // 여기서는 setIsSending(false) 하지 않음
                // STREAM_END, selection_box, input_box, REJECTED에서 해제
            } catch (error) {
                console.error("selection_box 전송 실패", error);

                setIsSending(false);
                setQueueStatus(null);

                // 전송 실패 시 기존 선택 버튼 다시 활성화
                if (selectionMessageId) {
                    setChatList(prev =>
                        prev.map(item =>
                            item.id === selectionMessageId
                                ? {
                                    ...item,
                                    submitted: false,
                                    selectedValue: null,
                                }
                                : item
                        )
                    );
                }

                setChatList(prev => [
                    ...prev,
                    {
                        id: crypto.randomUUID(),
                        type: "system",
                        text:
                            error.response?.data?.message ||
                            "선택 항목 전송 중 오류가 발생했습니다.",
                        date: getCurrentDate(),
                        chatTime: getCurrentTime(),
                    },
                ]);
            }
        },
        [isSending, sseStatus]
    );

    //----호출관련---
    const callChatBotApi = useCallback(async (question) => {
        const jToken = localStorage.getItem('jToken');
        const content = question?.trim();

        const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

        //어느 병원인지 알 수 없어서 일단 012 하드코딩
        const patientId = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012").patientId;

        if (isSending || !content) {
            return;
        }

        if (sseStatus !== "connected") {
            console.error("SSE가 연결되지 않았습니다.");
            return;
        }

        setIsFlying(true);
        setTextQuestion("");
        setIsSending(true);
        setQueueStatus(null);
        streamingMessageIdRef.current = null;
        lastAiMessageIdRef.current = null;

        const userMessage = {
            id: crypto.randomUUID(),
            type: "user",
            text: content,
            date: getCurrentDate(),
            chatTime: getCurrentTime(),
        };

        // 기존 목록을 유지하면서 추가해야 함
        setChatList(prev => [...prev, userMessage]);

        try {
            const body = {
                sessionId: sessionIdRef.current,
                message: content,
                requestedReturnType: "text",
                patientId : patientId,
                accessToken: jToken,
                entryContext: initialConnectRef.current ? "daily_" + mode : "general",
            };

            console.log(
                "[CHAT SEND]",
                "sessionId =", sessionIdRef.current
            );

            await axiosApi.post("/chat/send", body, {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                },
                noLoading: true,
            });

            if(initialConnectRef.current) {
                initialConnectRef.current = false;
            }
            // 여기서 setIsSending(false) 하면 안 됨
            // AI의 STREAM_END 또는 REJECTED를 받을 때 해제
        } catch (error) {
            console.error("메시지 전송 실패", error);

            setIsSending(false);
            setQueueStatus(null);

            setChatList(prev => [
                ...prev,
                {
                    id: crypto.randomUUID(),
                    type: "system",
                    text:
                        error.response?.data?.message ||
                        "메시지 전송 중 오류가 발생했습니다.",
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                },
            ]);
        }
    }, [isSending, sseStatus]);

    const handleClickFeedback = useCallback(async (chttMsgId, feedback, questionTime) => {

        const url = "/chatbot/feedback"

        const body = {
            // chttMsgId : chttMsgId,
            // patntInfoId : patntObj.patntInfoId,
            // feedback : feedback,
            // questionTime : questionTime
        }

        const jToken = localStorage.getItem('jToken');

        const requestOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            },
        }


        try {
            const res = await axiosApi.post(url, body, requestOptions);
            if (res.status === 200) {
                //todo..
            } else {
                const msg = res.data?.message || '피드백 저장 중 오류가 발생했습니다.';
                // setCmmAlertText(msg);
                // setIsCmmAlertOpen(true);
            }
        } catch (error) {
            const msg =
            error.response?.data?.message ||
            error.message ||
            '피드백 저장 중 오류가 발생했습니다.';

            // setCmmAlertText(msg);
            // setIsCmmAlertOpen(true);

        }
        //answer가 리턴옴.. "answer": "피드백 저장이 완료되었습니다." 이런식으로 뭘 할수있지?

    },[])

    const handleQueueStatus = useCallback((data) => {
        if (data.status === "QUEUED") {
            setQueueStatus({
                status: "QUEUED",
                aheadCount: data.aheadCount ?? 0,
                message:
                    data.aheadCount === 0
                        ? "현재 대기 중입니다. 다음 처리 순서입니다."
                        : `현재 대기 중입니다. 앞에 ${data.aheadCount}개의 요청이 있습니다.`,
            });

            return;
        }

        if (data.status === "STARTED") {
            setQueueStatus({
                status: "STARTED",
                message: "AI가 답변을 생성하고 있습니다.",
            });

            return;
        }

        if (data.status === "REJECTED") {
            setQueueStatus(null);
            setIsSending(false);

            setChatList(prev => [
                ...prev,
                {
                    id: crypto.randomUUID(),
                    type: "system",
                    text:
                        "현재 요청이 많아 질문을 접수할 수 없습니다. " +
                        "잠시 후 다시 시도해 주세요.",
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                },
            ]);
        }
    }, []);

    const handleInputBoxSubmit = useCallback(
        async (inputBoxMessageId, values) => {
            if (isSending) {
                return;
            }
            const jToken = localStorage.getItem('jToken');
            const message = JSON.stringify(values);

            const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

            //어느 병원인지 알 수 없어서 일단 012 하드코딩
            const patientId = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012").patientId;

            setIsSending(true);
            setQueueStatus(null);
            streamingMessageIdRef.current = null;
            lastAiMessageIdRef.current = null;

            // 기존 input_box를 제출 완료 상태로 변경
            setChatList(prev =>
                prev.map(item =>
                    item.id === inputBoxMessageId
                        ? {
                            ...item,
                            submitted: true,
                        }
                        : item
                )
            );

            // 사용자가 입력한 값을 채팅에도 표시
            setChatList(prev => [
                ...prev,
                {
                    id: crypto.randomUUID(),
                    type: "user",
                    text: message,
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                },
            ]);

            try {
                await axiosApi.post(
                    "/chat/send",
                    {
                        sessionId: sessionIdRef.current,
                        message,
                        requestedReturnType: "input_box",
                        patientId : patientId,
                        accessToken: jToken,
                        entryContext: initialConnectRef.current ? "daily_" + mode : "general",
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${jToken}`,
                        },
                        noLoading: true,
                    }
                );
                if(initialConnectRef.current) {
                    initialConnectRef.current = false;
                }
            } catch (error) {
                console.error("input_box 전송 실패", error);

                setIsSending(false);
                setQueueStatus(null);

                setChatList(prev => [
                    ...prev,
                    {
                        id: crypto.randomUUID(),
                        type: "system",
                        text:
                            error.response?.data?.message ||
                            "입력값 전송 중 오류가 발생했습니다.",
                        date: getCurrentDate(),
                        chatTime: getCurrentTime(),
                    },
                ]);
            }
        },
        [isSending]
    );
    //----호출관련---

    //----sse 관련----
    const handleSseMessage = useCallback((msg) => {

        if (msg.type === "STREAM") {
            setQueueStatus(null);

            const currentStreamingId = streamingMessageIdRef.current;

            // 첫 번째 스트리밍 조각
            if (!currentStreamingId) {
                const newId = crypto.randomUUID();

                // setState updater 바깥에서 ref 변경
                streamingMessageIdRef.current = newId;
                lastAiMessageIdRef.current = newId;

                const newMessage = {
                    id: newId,
                    type: "bot",
                    responseType: "text",
                    text: msg.content || "",
                    isStreaming: true,
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                };

                setChatList(prev => [
                    ...prev,
                    newMessage,
                ]);

                return;
            }

            // 두 번째 이후 스트리밍 조각
            setChatList(prev =>
                prev.map(item =>
                    item.id === currentStreamingId
                        ? {
                            ...item,
                            text:
                                `${item.text || ""}` +
                                `${msg.content || ""}`,
                        }
                        : item
                )
            );

            return;
        }

        if (msg.type === "STREAM_END") {
            setQueueStatus(null);

            const currentStreamingId =
                streamingMessageIdRef.current;

            if (currentStreamingId) {
                setChatList(prev =>
                    prev.map(item =>
                        item.id === currentStreamingId
                            ? {
                                ...item,
                                isStreaming: false,
                                errorMessage:
                                    msg.content || null,
                                chatTime:
                                    // msg.timestamp ||
                                    // item.chatTime ||
                                    getCurrentTime(),
                            }
                            : item
                    )
                );
            } else if (msg.content) {
                const errorMessage = {
                    id: crypto.randomUUID(),
                    type: "bot",
                    responseType: "error",
                    text: msg.content,
                    isStreaming: false,
                    date: getCurrentDate(),
                    chatTime: getCurrentTime(),
                };

                setChatList(prev => [
                    ...prev,
                    errorMessage,
                ]);
            }

            streamingMessageIdRef.current = null;
            setIsSending(false);
        }
    }, []);
    //----sse 관련----

    //----날짜관련----

    const getCurrentDateStr = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");

        const dayNames = ["일", "월", "화", "수", "목", "금", "토"]; // 요일 배열
        const dayOfWeek = dayNames[now.getDay()]; // getDay()는 0(일요일) ~ 6(토요일)

        return `${year}.${month}.${day}(${dayOfWeek})`;
    };

    const getCurrentDate = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");

        return `${year}${month}${day}`;
    };

    const getCurrentTime = () => {
        const now = new Date();
        return now.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    };

    const formatKorTime = (timeStr) => {
        // timeStr: "HHmmss" 또는 "HHmm"
        if (!timeStr || timeStr.length < 4) return "";

        const hour24 = parseInt(timeStr.substring(0, 2), 10);
        const minute = parseInt(timeStr.substring(2, 4), 10);

        const ampm = hour24 < 12 ? "오전" : "오후";
        let hour12 = hour24 % 12;
        if (hour12 === 0) hour12 = 12;

        return `${ampm} ${hour12}:${minute.toString().padStart(2, "0")}`;
    }

    //----날짜관련----

    //----채팅 히스토리 관련----
    const convertChatHistory = (chatMsgList = []) => {

        const result = [];
        let previousDate = null;

        chatMsgList.forEach((item) => {

            const dt = dayjs(item.timestamp);
            const date = dt.format('YYYYMMDD');
            const dayNames = ['일', '월', '화', '수', '목', '금', '토'];

            const dateStr = `${dt.format('YYYY.MM.DD')}(${dayNames[dt.day()]})`;
            const chatTime = dt.format('A hh:mm').replace('AM', '오전').replace('PM', '오후');

            // 날짜 변경 시 날짜 구분선
            if (previousDate !== date) {
                result.push({
                    id: `date-${date}`,
                    type: 'date',
                    date,
                    dateStr,
                });
                previousDate = date;
            }

            if (item.sender === 'USER') {
                result.push({
                    id: `user-${item.requestId}`,
                    requestId: item.requestId,
                    messageId: item.messageId,
                    type: 'user',
                    text: item.content,
                    date,
                    chatTime,
                    isHistory: true,
                });

                return;
            }


            let rawMessage = item.message || {};

            if (typeof rawMessage === 'string') {
                try {
                    rawMessage = JSON.parse(rawMessage);
                } catch (e) {
                    rawMessage = { text: rawMessage };
                }
            }

            const message = rawMessage.message || rawMessage;

            const responseType =
                item.responseType ||
                rawMessage.message_type ||
                'text';

            if (responseType === 'selection_box') {
                result.push({
                    id: `ai-${item.requestId}`,
                    requestId: item.requestId,
                    messageId: item.messageId,
                    type: 'bot',
                    responseType: 'selection_box',
                    text: message.text || '',
                    messageTitle: message.message_title || '',
                    tables: message.tables || [],
                    tags: message.selections || [],
                    date,
                    chatTime,
                    isStreaming: false,
                    submitted: true,
                    isHistory: true,
                });

                return;
            }


            if (responseType === 'input_box') {
                result.push({
                    id: `ai-${item.requestId}`,
                    requestId: item.requestId,
                    messageId: item.messageId,
                    type: 'bot',
                    responseType: 'input_box',
                    text: message.text || '',
                    messageTitle: message.message_title || '',
                    tables: message.tables || [],
                    inputs: message.inputs || [],
                    date,
                    chatTime,
                    isStreaming: false,
                    submitted: true,
                    isHistory: true,
                });

                return;
            }
            result.push({
                id: `ai-${item.requestId}`,
                requestId: item.requestId,
                messageId: item.messageId,
                type: 'bot',
                responseType: 'text',
                text: message.text || '',
                date,
                chatTime,
                isStreaming: false,
                submitted: true,
                isHistory: true,
            });
        });


        return result;
    };
    //----채팅 히스토리 관련----

    return (
        <>
            <HeadSub title="챗봇"/>

            <div ref={topAnchorRef} style={{ position: 'fixed', top: 0, left: 0, width: 1, height: 1, opacity: 0, pointerEvents: 'none' }} />

                <div id="sub-content" data-layout="blue">
                    <div
                        ref={scrollBoxRef}
                        className={style['chat-scroll']}
                        style={{ bottom: `calc(var(--sp-84) + ${keyboardHeight}px)` }}
                    >
                    <div className="inner-wrap" data-pad="normal">

                        <ChatListComp
                            chatList={chatList}
                            handleClickFeedback={handleClickFeedback}
                            queueStatus={queueStatus}
                            handleInputBoxSubmit={handleInputBoxSubmit}
                            handleTagClick={handleTagClick}
                        />

                        <div ref={chatEndRef} />
                    </div>
                    </div>


                    <div
                        className={style["bottom-fixed-box"]}
                        style={{
                            transform: `translateY(${-keyboardHeight}px)`
                        }}

                    >
                        <button className={style['attach-btn']} disabled>
                            <img src={iconAttach} alt="첨부파일 추가버튼" />
                            <span className='blind'>첨부파일</span>
                        </button>

                        <div className={style["in-box"]}>
                            <div className={style["input-box"]}>
                                <input
                                    type="text"
                                    placeholder="내용을 입력하세요"
                                    value={textQuestion}
                                    onChange={(e) => setTextQuestion(e.target.value)}
                                    disabled={isSending || sseStatus !== "connected"}
                                    onKeyDown={(e) => {
                                        if (
                                            e.key === "Enter" &&
                                            !e.nativeEvent.isComposing &&
                                            !isSending
                                        ) {
                                            callChatBotApi(textQuestion);
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        <button className={style['voice-btn']} disabled>
                            <img src={iconVoice} alt="음성버튼" />
                            <span className='blind'>음성입력</span>
                        </button>
                        <button
                            className={`${style['push-btn']} ${isFlying ? style['sending'] : ''}`}
                            disabled={!textQuestion.trim() || isSending || sseStatus !== "connected"}
                            onClick={() => callChatBotApi(textQuestion)}
                            onAnimationEnd={() => setIsFlying(false)}
                            aria-label="보내기"
                        ></button>

                    </div>
                </div>
        </>
    )
}

export default ServiceChat
